/* globals THREE */

import { Config } from 'config';

import { assign, now } from 'lodash';

import { Point } from 'cdl';

const { Vector3 } = THREE;

const _parseFloat = parseFloat;

export function setObjectPosition(object,bbCenter) {
  object.position.set(-bbCenter.x,-bbCenter.y,-bbCenter.z);
  object.matrixWorldNeedsUpdate = true;
}

function n2s(n) {
  return n.toFixed(4);
}

export function vector3ToString(v) {
  return n2s(v.x)+' '+n2s(v.y)+' '+n2s(v.z);
}

export function vector3FromString( string ) {
  const s = string.split(' ');
  return new Vector3(_parseFloat(s[0]),_parseFloat(s[1]),_parseFloat(s[2]));
}

export function rotationToString(v) {
  return n2s(v.x)+' '+n2s(v.y)+' '+n2s(v.z)+' '+v.order;
}

export function cameraToString(camera,target) {
  return vector3ToString(camera.position)+','+rotationToString(camera.rotation)+','+vector3ToString(target);
}

export function cameraStateFromString( string ) {
  const parts = string.split(',');
  return {
    pos    : vector3FromString( parts[0] ),
    target : vector3FromString( parts[2] )
  };
}

function properFaceNormal(face) {
  if( face ) {
    const face_normal = face.normal;
    if( face_normal && face_normal.lengthSq() === 0 ) {
      return false;
    }
  }
  return true;
}

function properVertexNormal(face) {
  if( face ) {
    const vertexNormal = face.vertexNormals[0];
    if( vertexNormal && vertexNormal.lengthSq() === 0 ) {
      return false;
    }
  }
  return true;
}

export function processGeometry(geometry/*,divisions*/) {

  const smooth = geometry; // Clone THREE.GeometryUtils.clone( geometry );

  // Next, we need to merge vertices to clean up any unwanted vertex.
  // smooth.mergeVertices();

  if( ! Config.useBufferGeometry ) {

    const face0 = smooth.faces[0],
          face1 = smooth.faces[1];

    const computeFaceNormals = Config.computeFaceNormals;
    if( computeFaceNormals === 'Forced' ||
      ( computeFaceNormals === 'Auto' && ( ! properFaceNormal(face0) || ! properFaceNormal(face1) ) ) ) {

      console.log("Computing face normals...");
      smooth.computeFaceNormals();
    }

    const computeVertexNormals = Config.computeVertexNormals;
    if( computeVertexNormals === 'Forced' ||
      ( computeVertexNormals === 'Auto' && ( ! properVertexNormal(face0) || ! properVertexNormal(face1) ) ) ) {
      console.log("Computing vertex normals...");
      smooth.computeVertexNormals();
    }

    /*
    if( divisions > 0 ) {

      // Create a new instance of the modifier and pass the number of divisions.
      const modifier = new THREE.SubdivisionModifier(divisions);

      // Apply the modifier to our cloned geometry.
      modifier.modify( smooth );

      smooth.uvsNeedsUpdate = true;
    }
    */
  }

  return smooth;
}

export const CameraAnimation = function(config){
  assign(this,config);
  assign(this,{
    start: now(),
    from: {
      pos: config.camera.position.clone(),
      target: config.controls.target.clone()
    }
  });
  this.finished = false;
};
CameraAnimation.prototype = {

  update(){

    if( this.finished ){
      return false;
    }
    const { controls, camera, to, from, start, ms } = this;

    const

    t = now(),

    ellapsed = t-start,

    to_pos    = to.pos   , from_pos    = from.pos,
    to_target = to.target, from_target = from.target;

    if( ellapsed >= ms ) {

      camera.position.copy(to_pos);
      controls.target.copy(to_target);
      controls.update();
      this.finished = true;

      return false;
    }
    else {

      const

      current = ellapsed / ms,

      // The next target is a direct interpolation between from and to targets

      nextTarget = to.target.clone().sub(from_target).multiplyScalar(current).add(from_target),

      // The nextPos y is a direct interpolation, x and z moves in an circle around the model

      from_xz = new Point(from_pos.x-from_target.x,from_pos.z-from_target.z),
        to_xz = new Point(  to_pos.x-  to_target.x,  to_pos.z-  to_target.z),

      theta_from  = from_xz.angle_rad(),
      theta_delta = Point.turnAngle_rad( from_xz, to_xz ),

      theta = theta_from + current * theta_delta,

      from_radius = from_xz.norm(),
        to_radius =   to_xz.norm(),

      radius = (to_radius-from_radius)*current+from_radius,

      nextPos = (new Vector3( radius * Math.cos( theta ), 0, radius * Math.sin( theta ) )).add(nextTarget);

      nextPos.y = (to_pos.y-from_pos.y)*current+from_pos.y;

      camera.position.copy(nextPos);
      controls.target.copy(nextTarget);
      controls.update();
    }
    return true;
  }
};

export function parseGeometry( json ) {

  const loader = new THREE.JSONLoader();

  let originalGeometry = loader.parse(json).geometry;

  if( ! Config.useBufferGeometry && originalGeometry ) {
    if( originalGeometry instanceof THREE.BufferGeometry ) {
      originalGeometry = new THREE.Geometry().fromBufferGeometry( originalGeometry );
    }
  }

  const smooth3D = Config.smooth3D;
  return processGeometry( originalGeometry, smooth3D ? parseInt(smooth3D) : 0 );
}

export function uvFromViewPoint( object, camera, viewPoint, width, height ) {

  camera.updateMatrixWorld();
  camera.updateProjectionMatrix();

  const vector = new Vector3( ( viewPoint.x / width ) * 2 - 1, - ( viewPoint.y / height ) * 2 + 1, 0.5 );

  vector.unproject(camera);

  const raycaster = new THREE.Raycaster( camera.position, vector.sub( camera.position ).normalize() );

  const intersects = raycaster.intersectObject( object, true );

  if( intersects.length > 0 ) {

    const uv = intersects[0].uv;
    return uv ? new Point(uv.x,uv.y) : null;
  }
  return null;
}



/** WEBPACK FOOTER **
 ** ./src/ui/canvas3d/three-util.js
 **/